import script from "./DailyConfirmedOrdersChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyConfirmedOrdersChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyConfirmedOrdersChart.vue?vue&type=style&index=0&id=b53ea660&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b53ea660"]])

export default __exports__